import { Global } from '@emotion/react';
import { _htmlBodyHeight100 } from '~/modules/SDK/FrTemplate/v2/csssets/_htmlBodyHeight100';
import { _iosTouchCalloutHack } from '~/modules/SDK/FrTemplate/v2/csssets/_iosTouchCalloutHack';
import { _normalize_8_0_1 } from '~/modules/SDK/FrTemplate/v2/csssets/_normalize_8_0_1';
export const _CssRebase = () => {
    return <Global styles={[_normalize_8_0_1, _htmlBodyHeight100, _iosTouchCalloutHack]}/>;
};
_CssRebase.displayName = 'FrTemplate/v2/components/CssRebase';
